interface IconProps {
  color?: string
}

export function Passport({ color }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      width="18px"
      height="24px"
      viewBox="0 0 18 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8291 3.19449V4.26743L2.50761 4.26743C2.41496 4.26743 2.32366 4.27327 2.23406 4.28462C2.28854 4.24408 2.3525 4.21519 2.42267 4.20191L11.8926 2.41024C12.3792 2.31817 12.8291 2.69489 12.8291 3.19449ZM14.5424 4.28682V3.19449C14.5424 1.61241 13.1179 0.419479 11.5768 0.711038L2.10692 2.50271C1.0784 2.6973 0.333077 3.60347 0.333077 4.65939L0.333077 6.44403C0.333031 6.44991 0.333008 6.4558 0.333008 6.46169L0.333008 19.8095C0.333008 21.7559 1.89667 23.3337 3.82555 23.3337H14.1738C16.1027 23.3337 17.6663 21.7559 17.6663 19.8095V7.79155C17.6663 5.97085 16.298 4.47264 14.5424 4.28682ZM2.04633 19.8095L2.0464 6.45356C2.0507 6.20025 2.25554 5.99624 2.50761 5.99624L14.1738 5.99624C15.1564 5.99624 15.953 6.80003 15.953 7.79155V19.8095C15.953 20.8011 15.1564 21.6048 14.1738 21.6048H3.82555C2.84291 21.6048 2.04633 20.8011 2.04633 19.8095Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M8.99976 10.7246C8.04947 10.7246 7.27912 11.5019 7.27912 12.4608C7.27912 13.4197 8.04947 14.197 8.99976 14.197C9.95004 14.197 10.7204 13.4197 10.7204 12.4608C10.7204 11.5019 9.95004 10.7246 8.99976 10.7246ZM5.5658 12.4608C5.5658 10.5471 7.10323 8.99581 8.99976 8.99581C10.8963 8.99581 12.4337 10.5471 12.4337 12.4608C12.4337 14.3745 10.8963 15.9258 8.99976 15.9258C7.10323 15.9258 5.5658 14.3745 5.5658 12.4608Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M6.19051 18.5289C6.19051 18.0515 6.57405 17.6645 7.04717 17.6645H10.9522C11.4253 17.6645 11.8088 18.0515 11.8088 18.5289C11.8088 19.0063 11.4253 19.3933 10.9522 19.3933H7.04717C6.57405 19.3933 6.19051 19.0063 6.19051 18.5289Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  )
}
